<template>
  <div id="app">
    <v-app>
      <router-view></router-view>
      <v-footer height="auto" v-show="IsApp">
        <v-layout>
          <v-flex text-xs-center xs12>
            &copy; {{ new Date().getFullYear() }} —
            <strong>Cultura Technologies LLC.</strong>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  name: "App",
  data: () => ({}),
  computed: {
    IsApp() {
      return this.$route.name !== "login" ? true : false;
    },
  },
  beforeCreate() {
    this.$store.commit("initialiseStore");
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Roboto");

body {
  background: #fff;
  font-family: "Roboto", sans-serif;
}

#app {
  background: #fff;
}

.page {
  position: fixed;
  width: inherit;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 1s;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
